// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".method-line[data-v-6f97044b] {\n  color: var(--dark);\n  font-weight: 600 !important;\n}[dir] .method-line[data-v-6f97044b] {\n  background: #c4c4c4;\n}\n[dir] .method-line-message[data-v-6f97044b] {\n  border-radius: 0px;\n  border: 6px solid #c4c4c4;\n}\n.cancelled[data-v-6f97044b] {\n  text-decoration: line-through;\n  color: var(--danger);\n}", ""]);
// Exports
module.exports = exports;
